import React from "react";

import {
    getDataFromResponse,
    getDataWithPromise,
    getNumRowsFromResponse, handleAjaxError,
} from '../../DataFunctions/BaseDataFns';

import {UserTypeNames} from "../../globals";
import {UserTypes} from "../../globals";

export const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    display: 'inline-block',
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);

export const genericListboxFetch = ( url, id_field_name, text_field_name, additionalFields) =>
{
    return new Promise((resolve, reject) =>
    {
        if (url === null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                // Map the data into the format the listbox wants.
                // Each listbox will map the value and label elements from the returned listbox data
                const rval =  rows.map((entry) =>
                {
                    let arr = {} ;

                    // Add any additional fields to the response
                    if ( additionalFields !== undefined )
                    {
                        let initialValue = {};
                        arr = additionalFields.reduce((obj, item) => {
                            return {
                                ...obj,
                                [item]: entry[item],
                            };
                        }, initialValue);
                    }

                    return { value: +(entry[id_field_name]), label: entry[text_field_name], ...arr} ;
                }) ;

                resolve ( rval );
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    handleAjaxError(jqXHR, textStatus, error) ;

                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getFamilyTypes = () =>
{
    const url = Globals.APIFolder + '/generalJSON/family/listAllFamilyTypes' ;

    return genericListboxFetch( url, 'type_id', 'type_name') ;
}

export const getRetentionPeriods = ( school_id ) =>
{
    const url = Globals.APIFolder + '/gdpr/retentionperiods' + (( school_id === null || school_id === undefined ) ? '' : '/' + school_id );

    return genericListboxFetch( url, 'retention_period_id', 'retention_desc', ['free_text_flag']) ;
}

export const getDataSources = ( school_id ) =>
{
    const url = Globals.APIFolder + '/gdpr/datasources' + (( school_id === null || school_id === undefined ) ? '' : '/' + school_id );

    return genericListboxFetch( url, 'data_source_id', 'short_desc') ;
}

export const getRiskLevels = () =>
{
    const url = Globals.APIFolder + '/gdpr/risklevels' ;

    return genericListboxFetch( url, 'risk_level_id', 'risk_level_text') ;
}

export const getRiskTypes = () =>
{
    const url = Globals.APIFolder + '/gdpr/risktypes' ;

    return genericListboxFetch( url, 'risk_type_id', 'risk_type_desc') ;
}

export const getMotives = () =>
{
    const url = Globals.APIFolder + '/gdpr/motives' ;

    return genericListboxFetch( url, 'motive_id', 'motive_text') ;
}

export const getOwners= () =>
{
    const url = Globals.APIFolder + '/gdpr/owners' ;

    return genericListboxFetch( url, 'owner_id', 'owner_name', ['school_id']) ;
}

export const getSchoolTermData = ( ) =>
{
    const url = Globals.APIFolder + '/terms' ;

    return genericListboxFetch( url, 'year_term_id', 'friendly_name') ;
}

export const getYesNoData = ( dataType ) =>
{
    let options = [] ;

    if ( dataType === 'int')
    {
        options =
            [
                { value: 1, label: 'Yes'},
                { value: 0, label: 'No'},
            ];
    }
    else
    {
        options =
            [
                { value: 'Y', label: 'Yes'},
                { value: 'N', label: 'No'},
            ];
    }

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

export const getSchoolYearData = ( includeEarly ) =>
{
    let years = [] ;

    if ( includeEarly === true )
    {
        years = [
            { value: 14, label: 'Reception'},
            { value: 15, label: 'Nursery'},
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'}];
    }
    else
    {
        years = [
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'}];
    }

    return new Promise((resolve, reject) =>
    {
        resolve(years);
    });
}

export const getIncidentYearOptions = () =>
{
    //Note: First year is the start of recording incidents - 2019-20
    let years = [] ;
    let index = 1;

    let maxYear = new Date().getFullYear();
    const currMonth = new Date().getMonth()
    const minYear = 2019;

    //if the month > 7 (august) we need to add 1 to maxYear
    maxYear = currMonth > 7 ? maxYear + 1 : maxYear;

    for (var i = maxYear; i >= minYear; i--) {
        let obj = {};
        const prev_year = i-1;
        obj.value = i-1;
        obj.label = prev_year + '-' + i;
        years.push(obj);

        index++;
    }

    return new Promise((resolve, reject) =>
    {
        resolve(years);
    });
}

////////////////////////////
// School360
////////////////////////////

export const getSchools= () =>
{
    const NCC_LEA = 1;
    const url = Globals.APIFolder + '/school360/schools/' + NCC_LEA ;
    return genericListboxFetch( url, 'unenc_school_id', 'school_name') ;
}

export const getResources= (school_id, provided_by) =>
{
    const url = Globals.APIFolder + '/resources/' +school_id +'/external?provided_by=' + provided_by;
    return genericListboxFetch( url, 'shared_resource_id', 'platform_name') ;
}

export const getUserTypes= () =>
{
    const url = Globals.APIFolder + '/school360/usertypes?role=' + UserTypes.USER_TYPE_SCHOOL_ADMIN;
    return genericListboxFetch( url, 'type_id', 'display_name') ;
}

export const getSchoolGroups= (school_id) =>
{
    const url = Globals.APIFolder + '/school/' + school_id + '/groups?include_classes=Y ' ;
    return genericListboxFetch( url, 'group_id', 'group_name') ;
}

export const getGroupPupils= (group_id) =>
{
    const url = Globals.APIFolder + '/groups/' + group_id + '/members ' ;
    return genericListboxFetch( url, 'user_account_id', 'name') ;
}

export const getTeacherPupilData = ( dataType ) =>
{
    let options = [] ;

    options =
        [
            { value: 0, label: 'All'},
            { value: 2, label: 'Pupil'},
            { value: 1, label: 'Teacher'},
        ];

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

export const getAccessHoursData = ( dataType ) =>
{
    let options = [] ;

    options =
        [
            { value: 0, label: 'All'},
            { value: 1, label: 'In School Hours'},
            { value: 2, label: 'Outside School Hours'},
        ];

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

export const getUsageReportsData = ( user, user_type ) =>
{
    let options = [] ;

    options =
        [
            { value: 0, label: 'Resources - Pupil Access by Month'},
            { value: 1, label: 'Resources - Pupil Access Totals'},
            { value: 2, label: 'School360 - Access by Month'},
            { value: 3, label: 'School360 - Access Totals'},
        ];

    /*
    //Commented out due to graph never working - left it in as a comment in-case we ever want to redo this - (Jason A - 29.07.24)
   if(user_type === UserTypeNames.USER_TYPE_NAME_ADMIN){
       options.push({ value: 4, label: 'Resources - Access all Schools (Year from Today)'});
   }
   */

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}
